import ScheduleComponent from '@/modules/ScheduleComponent';
import moment from 'moment';
import React, { lazy } from 'react';
import * as Yup from 'yup';
import { mediaUrls } from 'globalconfig/constants/mediaUrls';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Modal = require(`globalcomponents/UI/Modal/${layout}`).default;
const Form = lazy(() => import(`globalcomponents/UI/Form/${layout}`));
const Button = lazy(() => import(`globalcomponents/UI/Button/${layout}`));
const SvgIcon = lazy(() => import(`globalcomponents/SvgIcon/${layout}`));

const SchedulerModal = ({
  config,
  setModalConfig,
  reportTypesList,
  handleEdit,
  handleDelete,
  callback,
  Styled,
  drivers,
  vehicles,
  history,
  i18n,
}) => {
  const { open, edit, content } = config;
  const item = content?.item;

  if (!open || !item) return null;

  const handleClose = () => setModalConfig({ open: false, edit: false, content: null });

  const renderContent = () => {
    if (content.type === 'delete') {
      return (
        <div className="deleteParent">
          <div className="imageSection">
            <SvgIcon value={mediaUrls.confirmIcon} alt="Confirm delete" />
          </div>
          <h2>{i18n.t('Are you sure you want to delete this scheduled report? \nPlease confirm.')}</h2>
          <div className="deletePopupBtn">
            <div className="cancelBtn">
              <Button label={i18n.t('Cancel')} onClick={handleClose} />
            </div>
            <div className="deletebtn">
              <Button
                label={i18n.t('common.deletePopup')}
                onClick={() => {
                  handleDelete(item.id);
                  handleClose();
                }}
              />
            </div>
          </div>
        </div>
      );
    }

    const initialValues = {
      recurrenceType: item.recurrenceType,
      recurrenceInterval: item.recurrenceInterval,
      scheduleEndDate: moment(item.scheduleEndDate).format('MM/DD/YYYY') || '',
      driverIds: item.driverIds || [],
      vehicleIds: item.vehicleIds || [],
    };

    return (
      <div className="scheduleForm">
        <div className="headWrapper" style={{ marginBottom: 15 }}>
          {`Report Type - `}
          <strong>{reportTypesList.find((r) => r.value === item.type)?.label || item.type}</strong>
        </div>
        <Form
          type="server"
          direction="column"
          initialValues={initialValues}
          RenderComponent={ScheduleComponent}
          handleOnSubmit={(fields) => {
            const data = {
              recurrenceType: fields.recurrenceType,
              recurrenceInterval: fields.recurrenceInterval,
              scheduleEndDate: fields.scheduleEndDate ? new Date(fields.scheduleEndDate).getTime() : null,
              id: item.id,
              type: item.type,
              requestDate: item.requestDate,
            };
            handleEdit({
              data,
              apiId: 'editSchedulingAPI',
              callback: (success) => {
                if (success) {
                  callback('success', 'Successfully edited.');
                  handleClose();
                } else {
                  callback('error', 'Something went wrong! Please try again.');
                }
              },
            });
          }}
          customProps={{ Styled, drivers, vehicles, editPage: true, history, i18n }}
          validationSchema={Yup.object()}
        />
      </div>
    );
  };

  return (
    <Modal
      width={edit ? '650px' : ''}
      exportDisplay={edit ? 'block' : 'flex'}
      open={open}
      setOpen={handleClose}
      deletePopup
      data={{ content: renderContent }}
      withCloseIcon={edit}
    />
  );
};

export default SchedulerModal;
